import { setUserPreferenceByKey } from "@/pages/settings/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useSetSquawkConnectionType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (value: string) =>
      setUserPreferenceByKey("squawk_connection_type", value),
    onSuccess: () => {
      // Invalidate the query to refetch the updated value
      queryClient.invalidateQueries({ queryKey: ["squawkConnectionTypePref"] });
    },
  });
};
